module.exports = {"Buy":"Buy","Rent":"Rent","Renovation":"Renovation","Commercial":"Commercial","Project":"Project","Find agent":"Find agent","Sign Up":"Sign Up","Sign In":"Sign In"}


//////////////////
// WEBPACK FOOTER
// ./src/Services/Geo/Translate/en.json
// module id = 324
// module chunks = 0